import { getMetrics } from './metrics';

const enum NetworkMetricType {
  GraphQLRetriesStarted = 'graphql_retries_started',
  GraphQLRetriesFailed = 'graphql_retries_failed',
  ItineraryHotelStaticInfoRetriesStarted = 'itinerary_hotel_static_info_retries_started',
  ItineraryHotelStaticInfoRetriesSucceeded = 'itinerary_hotel_static_info_retries_succeeded',
  ItineraryTransportStaticInfoRetriesStarted = 'itinerary_transport_static_info_retries_started',
  ItineraryTransportStaticInfoRetriesSucceeded = 'itinerary_transport_static_info_retries_succeeded',
}

const metrics = getMetrics();

export function trackGraphQLRetriesStarted(): void {
  const counter = metrics.getCounter(NetworkMetricType.GraphQLRetriesStarted);
  counter.inc({});
}

export function trackGraphQLRetriesFailed(): void {
  const counter = metrics.getCounter(NetworkMetricType.GraphQLRetriesFailed);
  counter.inc({});
}

export function trackItineraryHotelStaticInfoRetriesStarted(): void {
  const counter = metrics.getCounter(
    NetworkMetricType.ItineraryHotelStaticInfoRetriesStarted
  );
  counter.inc({});
}

export function trackItineraryHotelStaticInfoRetriesSucceeded(): void {
  const counter = metrics.getCounter(
    NetworkMetricType.ItineraryHotelStaticInfoRetriesSucceeded
  );
  counter.inc({});
}

export function trackItineraryTransportStaticInfoRetriesStarted(): void {
  const counter = metrics.getCounter(
    NetworkMetricType.ItineraryTransportStaticInfoRetriesStarted
  );
  counter.inc({});
}

export function trackItineraryTransportStaticInfoRetriesSucceeded(): void {
  const counter = metrics.getCounter(
    NetworkMetricType.ItineraryTransportStaticInfoRetriesSucceeded
  );
  counter.inc({});
}
